import React, { useContext } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Navbar as Nb, Nav } from 'react-bootstrap'

import AuthContext from '../context/auth/AuthContext'

function Navbar(props) {
    const ctxAuth = useContext(AuthContext)
    const { authenticated, logout, verifyUser } = ctxAuth

    let history = useHistory()
    const redirect = () => {
        history.push('/')
    }

    window.addEventListener('load', () => {
        verifyUser()
    })

    const sendData = (event) => {
        event.preventDefault()
        logout()
    }
    return (
        <Nb collapseOnSelect expand="lg" className="navbar-light bg-light">
            <div className="container-fluid px-5">
                <Link className="navbar-brand" to="/">Adopt</Link>
                {/* <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor03" aria-controls="navbarColor03" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button> */}
                <Nb.Toggle />
                <Nb.Collapse  id="navbarColor03">
                    {
                        authenticated ? (
                            <ul className="navbar-nav me-auto">
                                <li className="nav-item">
                                    <Nav.Link className="nav-link" aria-current="page" to="/addpet" eventKey="1" as={Link}>Add pet</Nav.Link>
                                </li>
                                <li className="nav-item">
                                    <Nav.Link className="nav-link" aria-current="page" to="/mypets" eventKey="2" as={Link}>My pets</Nav.Link>
                                </li>
                            </ul>
                        )
                        :
                        (
                            <ul className="navbar-nav me-auto">
                                <li className="nav-item">
                                    <div></div>
                                </li>
                            </ul>
                        )
                    }
                    {
                        authenticated ? (
                            <div>
                                <form onSubmit={(e) => {sendData(e)}}>
                                    <input type="submit" className="btn btn-outline-danger btn-sm" value="LogOut" onClick={redirect}/>
                                </form>
                            </div>
                        )
                        :
                        (
                        <div className="d-flex">
                            <div className="pe-2">
                                <Nav.Link className="btn btn-outline-dark btn-sm session" to="/signup" eventKey="1" as={Link}>SignUp</Nav.Link>
                            </div>
                            <div>
                                <Nav.Link className="btn btn-outline-dark btn-sm session" to="/login" eventKey="2" as={Link}>LogIn</Nav.Link>
                            </div>
                        </div>
                        )
                    }
                    
                </Nb.Collapse>
            </div>
        </Nb>
    )
}

export default Navbar
